import { createCommentVNode as _createCommentVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, vShow as _vShow, createVNode as _createVNode, withDirectives as _withDirectives, Fragment as _Fragment, createElementVNode as _createElementVNode, withCtx as _withCtx, withKeys as _withKeys, normalizeClass as _normalizeClass, renderList as _renderList, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6322dcae"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "android-seat"
}
const _hoisted_2 = { class: "top-nav posted" }
const _hoisted_3 = { class: "search" }
const _hoisted_4 = { class: "right-option" }
const _hoisted_5 = { class: "view-type" }
const _hoisted_6 = { class: "sort" }
const _hoisted_7 = { class: "op-text" }
const _hoisted_8 = { class: "theme" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "theme-label" }, null, -1 /* HOISTED */))
const _hoisted_10 = { class: "op-text" }
const _hoisted_11 = { class: "language" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "colour colour-yuyanqiehuan" }, null, -1 /* HOISTED */))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_expand = _resolveComponent("expand")!
  const _component_fold = _resolveComponent("fold")!
  const _component_Operation = _resolveComponent("Operation")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_input = _resolveComponent("el-input")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createCommentVNode(" 安卓端占位 "),
    ($setup.config.android)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1))
      : _createCommentVNode("v-if", true),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", {
        class: "menu_collapse",
        onClick: _cache[0] || (_cache[0] = ($event: any) => ($setup.handleSelect('switch_sidebar')))
      }, [
        _createCommentVNode("大屏幕"),
        ($setup.screenType)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _withDirectives(_createVNode(_component_expand, { class: "icon-operation" }, null, 512 /* NEED_PATCH */), [
                [_vShow, $setup.config.sidebarCollapse]
              ]),
              _withDirectives(_createVNode(_component_fold, { class: "icon-operation" }, null, 512 /* NEED_PATCH */), [
                [_vShow, !$setup.config.sidebarCollapse]
              ])
            ], 64 /* STABLE_FRAGMENT */))
          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              _createCommentVNode("小屏幕"),
              _createVNode(_component_Operation, { class: "icon-operation" })
            ], 2112 /* STABLE_FRAGMENT, DEV_ROOT_FRAGMENT */)),
        _createCommentVNode("<expand v-else class=\"icon-operation\"/>")
      ]),
      _createCommentVNode(" 搜索框 "),
      _withDirectives(_createElementVNode("div", _hoisted_3, [
        _createVNode(_component_el_input, {
          class: "search-input",
          modelValue: $setup.searchText,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (($setup.searchText) = $event)),
          clearable: "",
          onKeyup: _withKeys($setup.go_search, ["enter"])
        }, {
          prepend: _withCtx(() => [
            _createVNode(_component_el_select, {
              modelValue: $setup.searchType,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($setup.searchType) = $event)),
              placeholder: "Select",
              class: "search-select"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_option, {
                  label: _ctx.$t('search.manga'),
                  value: "manga"
                }, null, 8 /* PROPS */, ["label"]),
                _createVNode(_component_el_option, {
                  label: _ctx.$t('search.chapter'),
                  value: "chapter"
                }, null, 8 /* PROPS */, ["label"])
              ]),
              _: 1 /* STABLE */
            }, 8 /* PROPS */, ["modelValue"])
          ]),
          append: _withCtx(() => [
            _createVNode(_component_el_button, {
              icon: $setup.Search,
              onClick: $setup.go_search
            }, null, 8 /* PROPS */, ["icon"])
          ]),
          _: 1 /* STABLE */
        }, 8 /* PROPS */, ["modelValue", "onKeyup"])
      ], 512 /* NEED_PATCH */), [
        [_vShow, $setup.layoutLimit('search')]
      ]),
      _createCommentVNode("右侧菜单"),
      _createElementVNode("div", _hoisted_4, [
        _createCommentVNode(" 简化版搜索 "),
        _withDirectives(_createElementVNode("div", {
          class: "search-small",
          onClick: _cache[3] || (_cache[3] = ($event: any) => ($setup.router.push('/search')))
        }, [
          _createElementVNode("i", {
            class: "iconfont icon-sousuo",
            onClick: $setup.switch_view_type
          })
        ], 512 /* NEED_PATCH */), [
          [_vShow, $setup.layoutLimit('miniSearch')]
        ]),
        _createCommentVNode(" 视图切换 "),
        _withDirectives(_createElementVNode("div", _hoisted_5, [
          _createElementVNode("i", {
            class: _normalizeClass(['iconfont', $setup.viewClass]),
            onClick: $setup.switch_view_type
          }, null, 2 /* CLASS */)
        ], 512 /* NEED_PATCH */), [
          [_vShow, $setup.layoutLimit('view')]
        ]),
        _createCommentVNode(" 排序方式 "),
        _withDirectives(_createElementVNode("div", _hoisted_6, [
          _createElementVNode("i", {
            class: _normalizeClass(['sort-label', 'iconfont', 'icon-paixu']),
            onClick: $setup.switch_view_type
          }),
          _createVNode(_component_el_select, {
            modelValue: $setup.userConfig.order,
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (($setup.userConfig.order) = $event)),
            class: "sort-select",
            size: "default",
            onChange: $setup.sort_order_change
          }, {
            default: _withCtx(() => [
              (_openBlock(), _createElementBlock(_Fragment, null, _renderList($setup.sortOrder, (item) => {
                return _createVNode(_component_el_option, {
                  key: item,
                  label: _ctx.$t(`sortOrder.${item}`),
                  value: item
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.$t(`sortOrder.${item}`)), 1 /* TEXT */)
                  ]),
                  _: 2 /* DYNAMIC */
                }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["label", "value"])
              }), 64 /* STABLE_FRAGMENT */))
            ]),
            _: 1 /* STABLE */
          }, 8 /* PROPS */, ["modelValue"])
        ], 512 /* NEED_PATCH */), [
          [_vShow, $setup.layoutLimit('sort')]
        ]),
        _createCommentVNode(" 主题皮肤 "),
        _withDirectives(_createElementVNode("div", _hoisted_8, [
          _hoisted_9,
          _createVNode(_component_el_select, {
            modelValue: $setup.userConfig.theme,
            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (($setup.userConfig.theme) = $event)),
            class: "theme-select",
            size: "default",
            onChange: $setup.theme_change
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.theme, (item) => {
                return (_openBlock(), _createBlock(_component_el_option, {
                  key: item.value,
                  label: _ctx.$t(`theme.${item.value}`),
                  value: item.value
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("span", {
                      class: "op-color",
                      style: _normalizeStyle($setup.theme_color(item.value))
                    }, null, 4 /* STYLE */),
                    _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.$t(`theme.${item.value}`)), 1 /* TEXT */)
                  ]),
                  _: 2 /* DYNAMIC */
                }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["label", "value"]))
              }), 128 /* KEYED_FRAGMENT */))
            ]),
            _: 1 /* STABLE */
          }, 8 /* PROPS */, ["modelValue"])
        ], 512 /* NEED_PATCH */), [
          [_vShow, $setup.layoutLimit('theme')]
        ]),
        _createCommentVNode("切换语言"),
        _withDirectives(_createElementVNode("div", _hoisted_11, [
          _hoisted_12,
          _createVNode(_component_el_select, {
            modelValue: $setup.userConfig.language,
            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (($setup.userConfig.language) = $event)),
            class: "language-select",
            size: "default",
            onChange: $setup.language_change
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.languages, (item) => {
                return (_openBlock(), _createBlock(_component_el_option, {
                  key: item.value,
                  label: item.label,
                  value: item.value
                }, null, 8 /* PROPS */, ["label", "value"]))
              }), 128 /* KEYED_FRAGMENT */))
            ]),
            _: 1 /* STABLE */
          }, 8 /* PROPS */, ["modelValue"])
        ], 512 /* NEED_PATCH */), [
          [_vShow, $setup.layoutLimit('language')]
        ])
      ])
    ])
  ], 64 /* STABLE_FRAGMENT */))
}